import AccordionDrawer from './accordion-drawer.js';
import AccordionChildDrawer from './accordion-child-drawer.js';
import EVENT from '../enums/event.js';

const selectors = {
  drawer: '[data-accordion-drawer]',
  childDrawer: '[data-accordion-child-drawer]',
};

class Accordion {
  /**
   *
   * @param {Element} element
   */
  constructor(element) {
    this.accordion = element;

    if (!this.accordion) return;

    this.drawers = [...this.accordion.querySelectorAll(selectors.drawer)].map(
      drawer => new AccordionDrawer(drawer)
    );

    this.childDrawers = [
      ...this.accordion.querySelectorAll(selectors.childDrawer),
    ].map(childDrawer => new AccordionChildDrawer(childDrawer));

    this.init();
  }

  init() {
    this.registerEventListeners();
  }

  open(index) {
    if (this.drawers[index]) {
      this.drawers[index].open();
    }

    if (this.childDrawers[index]) {
      this.childDrawers[index].open();
    }
  }

  registerEventListeners() {
    this.closeDrawersEvents();
    this.closeChildDrawersEvents();
  }

  closeDrawersEvents() {
    this.accordion.addEventListener(EVENT.ACCORDION.DRAWERCLOSED, event => {
      this.drawers.forEach(drawer => {
        if (drawer !== event.detail.drawer) {
          if (drawer.button.getAttribute('aria-expanded') === 'true') {
            drawer.close();
          }
        }
      });
    });
  }

  closeChildDrawersEvents() {
    this.accordion.addEventListener(
      EVENT.ACCORDION.CHILDDRAWERCLOSED,
      event => {
        this.childDrawers.forEach(childDrawer => {
          if (childDrawer !== event.detail.childDrawer) {
            if (childDrawer.button.getAttribute('aria-expanded') === 'true') {
              childDrawer.close();
            }
          }
        });
      }
    );
  }
}

export default Accordion;
